<template>
  <v-container
    class="pa-2"
    grid-list-md
    fill-height
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        sm6
        md3
      >
        <count-widget 
          color="green"
          icon="mdi-account-tie"
          title="Active Visitors"
          :value="activeVisitors"
          style="max-width: 300px; margin: 0 auto"
          @refresh="doRefresh"
        />
      </v-flex>
      <v-flex
        xs12
        sm6
        md3
      >
        <count-widget 
          color="orange"
          icon="mdi-account-box-multiple"
          title="Total Visitors"
          :value="totalVisitors"
          style="max-width: 300px; margin: 0 auto"
          @refresh="doRefresh"
        />
      </v-flex>
      <v-flex
        xs12
        sm6
        md3
      >
        <count-widget 
          color="green"
          icon="people"
          title="Active Users"
          :value="$store.state.activeUsers"
          style="max-width: 300px; margin: 0 auto"
          @refresh="doRefresh"
        />
      </v-flex>
      <v-flex
        xs12
        sm6
        md3
      >
        <count-widget 
          color="orange"
          icon="mdi-account-group"
          title="Total Users"
          :value="$store.state.totalUsers"
          style="max-width: 300px; margin: 0 auto"
          @refresh="doRefresh"
        />
      </v-flex>
      <v-flex
        xs12
        sm6
        xl4
      >
        <feeds />
      </v-flex>
      <v-flex
        xs12
        sm6
        xl4
      >
        <tickets />
      </v-flex>
      <v-snackbar
        v-model="snackbar"
        :color="snackColor"
        :timeout="0"
        bottom
      >
        {{ snackbarMessage }}
        <v-btn
          flat
          @click.native="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import CountWidget from '@/components/common/CountWidget';

import _toArray from '@/mixins/util-mixin';
import Feeds from './Feeds';
import Tickets from './Tickets';

export default {
  name: 'Dashboard',
  components: {
    feeds: Feeds,
    tickets: Tickets,
    'count-widget': CountWidget
  },
  mixins: [_toArray],
  data() {
    return {
      visitorLog: [],
      totalUsers: 0,
      activeUsers: 0,
      snackbar: false,
      snackbarMessage: '',
      snackColor: 'primary'
    };
  },
  computed: {
    activeVisitors() {
      return this.$store.state.visitorLogs.filter(o => !o.checkOutDate).length;
    },
    totalVisitors() {
      return this.$store.state.visitorLogs.length;
    }
  },
  created() {
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'Dashboard' });
  },
  methods: {
    doRefresh(title) {
      switch (title) {
        case 'Active Visitors':
          this.$store.dispatch('getVisitorLog');
          break;

        case 'Total Visitors':
          this.$store.dispatch('getVisitorLog');
          break;

        case 'Total Users':
          this.$store.dispatch('getTotalUsers');
          break;

        case 'Active Users':
          this.$store.dispatch('getActiveUsers');
          break;
        default:
          break;
      }
    }
  }
};
</script>
